module.exports = __webpack_public_path__ + "img/Bodmer_LKW_neue_Blache.27bb25e.jpg";